export default "__VITE_ASSET__D0w_QzOv__"